export default "//static.tradera.net/touchweb/static/output/images/category-construction-tools.429736aa.svg";